import React from 'react'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { useIntegrationDocsURL } from '../../../../../../utils/docs'
import OntimeApi from './OntimeApi'
import DimensionMap from '../dimensionMap/DimensionMap'

const Ontime = () => {
  const { t } = useTranslation()
  const integrationDocs = useIntegrationDocsURL()

  const items = [
    {
      label: t('integrationsPage:api'),
      key: 'api',
      children: <OntimeApi credentialsRequestUrl="/ontime/authentication/{companyId}" />
    },
    {
      label: t('global:costCentres'),
      key: 'dimensions',
      children: (
        <DimensionMap
          getDimensionsUrl="/ontime/dimensions/{companyId}"
          updateDimensionsUrl="/ontime/dimensions/{companyId}/{id}"
          dataKey="id"
        />
      )
    }
  ]

  return (
    <>
      <a href={integrationDocs.external('ontime')} target="_blank" rel="noopener noreferrer">
        {t('header:manual')}
      </a>
      <Tabs items={items} destroyOnHidden />
    </>
  )
}

export default Ontime
